import { IconButton } from "@itwin/itwinui-react"
import styles from "./OverlayButton.module.css";
import { SvgExport } from "@itwin/itwinui-icons-react";
import { useAppSelector } from "store";

export const OverlayButton = () => {
  const sandbox = useAppSelector((state) => state.activeSandbox.metadata);

  return (<div className={styles.container}>
    <IconButton as="a" className={styles.overlayButton} href={`${window.location.origin}/sandboxes/${sandbox?.username}/${sandbox?.name}`} target="_blank" styleType="borderless"><SvgExport /></IconButton>
  </div>)
}